/**
 * Обрезает длинный текст, оставляя только последние visibleLength символов
 * и заменяя обрезанное начало на префикс-индикатор.
 *
 * @param text - исходный текст
 * @param visibleLength - количество видимых символов с конца (по умолчанию 12)
 * @param prefix - префикс-индикатор обрезки (по умолчанию '…')
 * @returns обрезанный текст или исходный, если он короче visibleLength
 */
export const truncateStart = (
  text: string,
  visibleLength: number = 12,
  prefix: string = "…",
): string => {
  if (!text || text.length <= visibleLength) {
    return text;
  }

  return `${prefix}${text.slice(-visibleLength)}`;
};
